// generated import statements - any manual change made here will be overwritten automatically. 

import ArticlesInsight from '../../Features/Blocks/ArticlesInsight/ArticlesInsight.init.js';

import ContextBanner from '../../Features/Blocks/BreakingNews/ContextBanner/ContextBanner.init.js';

import CalculatorCompareTable from '../../Features/Blocks/Calculators/NewLoanCalculator/frontend/components/CalculatorCompareTable/CalculatorCompareTable.init.js';

import CalculatorSummary from '../../Features/Blocks/Calculators/NewLoanCalculator/frontend/components/CalculatorSummary/CalculatorSummary.init.js';

import FormRadioGroupInput from '../../Features/Blocks/Calculators/NewLoanCalculator/frontend/components/FormRadioGroupInput/FormRadioGroupInput.init.js';

import NewLoanCalculatorInputs from '../../Features/Blocks/Calculators/NewLoanCalculator/frontend/components/NewLoanCalculatorInputs/NewLoanCalculatorInputs.init.js';

import NewLoanCalculatorInput from '../../Features/Blocks/Calculators/NewLoanCalculator/frontend/NewLoanCalculatorInput/NewLoanCalculatorInput.init.js';

import AdjustLoanContent from '../../Features/Blocks/Calculators/NewLoanCalculator/frontend/NewLoanCalculatorResult/ModalContent/AdjustLoanContent/AdjustLoanContent.init.js';

import SwitchLoanTypeContent from '../../Features/Blocks/Calculators/NewLoanCalculator/frontend/NewLoanCalculatorResult/ModalContent/SwitchLoanTypeContent/SwitchLoanTypeContent.init.js';

import NewLoanCalculatorResult from '../../Features/Blocks/Calculators/NewLoanCalculator/frontend/NewLoanCalculatorResult/NewLoanCalculatorResult.init.js';

import NewLoanCalculatorResultDesktop from '../../Features/Blocks/Calculators/NewLoanCalculator/frontend/NewLoanCalculatorResult/NewLoanCalculatorResultDesktop/NewLoanCalculatorResultDesktop.init.js';

import NewLoanCalculatorResultMobile from '../../Features/Blocks/Calculators/NewLoanCalculator/frontend/NewLoanCalculatorResult/NewLoanCalculatorResultMobile/NewLoanCalculatorResultMobile.init.js';

import HighchartGraph from '../../Features/Blocks/HighCharts/frontend/HighchartGraph/HighchartGraph.init.js';

import SignupMultipleNewsletters from '../../Features/Blocks/Newsletters/NewslettersSignup/SignupMultipleNewsletters/SignupMultipleNewsletters.init.js';

import SignupSingleNewsletter from '../../Features/Blocks/Newsletters/NewslettersSignup/SignupSingleNewsletter/SignupSingleNewsletter.init.js';

import SignupStepActions from '../../Features/Blocks/Newsletters/NewslettersSignup/SignupStepActions/SignupStepActions.init.js';

import SignupStepEmail from '../../Features/Blocks/Newsletters/NewslettersSignup/SignupStepEmail/SignupStepEmail.init.js';

import SignupStepFullname from '../../Features/Blocks/Newsletters/NewslettersSignup/SignupStepFullname/SignupStepFullname.init.js';

import SignupStepReceipt from '../../Features/Blocks/Newsletters/NewslettersSignup/SignupStepReceipt/SignupStepReceipt.init.js';

import SignupStepSelectNewsletters from '../../Features/Blocks/Newsletters/NewslettersSignup/SignupStepSelectNewsletters/SignupStepSelectNewsletters.init.js';

import SendCalculationStepActions from '../../Features/Blocks/SendCalculation/Actions/SendCalculationStepActions.init.js';

import VideoBlock from '../../Features/Blocks/Video/VideoBlock.init.js';

import FindCenterContactPersons from '../../Features/FindCenter/Blocks/FindCenterContactPersons/FindCenterContactPersons.init.js';

import FindCenterMapAndEmployees from '../../Features/FindCenter/Blocks/FindCenterMapAndEmployees/FindCenterMapAndEmployees.init.js';

import CenterMap from '../../Features/FindCenter/Blocks/FindMap/CenterMap.init.js';

import JobApplication from '../../Features/JobPosting/Pages/JobApplication/JobApplication.init.js';

import FooterContact from '../../Features/Navigation/Blocks/FooterContact/FooterContact.init.js';

import Menu from '../../Features/Navigation/Menu/Menu.init.js';

import FeedbackBlock from '../../Features/Ratings/FeedbackBlock/FeedbackBlock.init.js';

import FeedbackStepOne from '../../Features/Ratings/FeedbackBlock/FeedbackStepOne/FeedbackStepOne.init.js';

import FeedbackStepThree from '../../Features/Ratings/FeedbackBlock/FeedbackStepThree/FeedbackStepThree.init.js';

import FeedbackStepTwo from '../../Features/Ratings/FeedbackBlock/FeedbackStepTwo/FeedbackStepTwo.init.js';

import CardMediumPI from '../../Features/Totalkredit/BankBranchMap/CardMediumPI/CardMediumPI.init.js';

import PIMap from '../../Features/Totalkredit/BankBranchMap/PIMap/PIMap.init.js';

import AnkerMenu from '../../Foundation/FrontendComponents/AnkerMenu/AnkerMenu.init.js';

import MitNykreditMenu from '../../Foundation/FrontendComponents/MitNykredit/MitNykreditMenu/MitNykreditMenu.init.js';

import Breadcrumbs from '../../Foundation/Navigation/Breadcrumbs/Breadcrumbs.init.js';

import AiAssistant from './components/AiAssistant/AiAssistant.init.js'

import AnnualReportsTable from './components/AnnualReportsTable/AnnualReportsTable.init.js'

import CalculatorInfoBox from './components/CalculatorInfoBox/CalculatorInfoBox.init.js'

import CalculatorTable from './components/CalculatorTable/CalculatorTable.init.js'

import ChatPanel from './components/ChatPanel/ChatPanel.init.js'

import ChatPanelFloatingTrigger from './components/ChatPanelFloatingTrigger/ChatPanelFloatingTrigger.init.js'

import ChatPanelTrigger from './components/ChatPanelTrigger/ChatPanelTrigger.init.js'

import ContactAdvisorBlock from './components/ContactAdvisorBlock/ContactAdvisorBlock.init.js'

import ContactCard from './components/ContactCard/ContactCard.init.js'

import ContactCardBasic from './components/ContactCardBasic/ContactCardBasic.init.js'

import ContactCardOnboarding from './components/ContactCardOnboarding/ContactCardOnboarding.init.js'

import ContactCardPermission from './components/ContactCardPermission/ContactCardPermission.init.js'

import ContactStepCategoryContent from './components/ContactStepCategoryContent/ContactStepCategoryContent.init.js'

import ContactStepComments from './components/ContactStepComments/ContactStepComments.init.js'

import ContactStepContent from './components/ContactStepContent/ContactStepContent.init.js'

import ContactStepIntro from './components/ContactStepIntro/ContactStepIntro.init.js'

import ContactStepNewsletters from './components/ContactStepNewsletters/ContactStepNewsletters.init.js'

import ContactStepOnboardingContent from './components/ContactStepOnboardingContent/ContactStepOnboardingContent.init.js'

import CurrentFundPrices from './components/CurrentFundPrices/CurrentFundPrices.init.js'

import CustomForm from './components/CustomForm/CustomForm.init.js'

import DocumentArchive from './components/DocumentArchive/DocumentArchive.init.js'

import DynamicDocumentList from './components/DynamicDocumentList/DynamicDocumentList.init.js'

import DynamicTable from './components/DynamicTable/DynamicTable.init.js'

import FeedbackToolbar from './components/FeedbackToolbar/FeedbackToolbar.init.js'

import FilterTabs from './components/FilterTabs/FilterTabs.init.js'

import GenericInput from './components/GenericInput/GenericInput.init.js'

import GoogleMapsWithMarkers from './components/GoogleMapsWithMarkers/GoogleMapsWithMarkers.init.js'

import HistoricFundPrices from './components/HistoricFundPrices/HistoricFundPrices.init.js'

import InvestmentFundTable from './components/InvestmentFundTable/InvestmentFundTable.init.js'

import JobPostingsTable from './components/JobPostingsTable/JobPostingsTable.init.js'

import LegalText from './components/LegalText/LegalText.init.js'

import Modal from './components/Modal/Modal.init.js'

import MultiSelectDropdown from './components/MultiSelectDropdown/MultiSelectDropdown.init.js'

import NewCarLoanCalculatorAdjustLoan from '../../Frontend/src/components/NewCarLoanCalculator/Components/NewCarLoanCalculatorAdjustLoan/NewCarLoanCalculatorAdjustLoan.init.js';

import NewCarLoanCalculatorInputs from '../../Frontend/src/components/NewCarLoanCalculator/Components/NewCarLoanCalculatorInputs/NewCarLoanCalculatorInputs.init.js';

import NewCarLoanCalculatorSummary from '../../Frontend/src/components/NewCarLoanCalculator/Components/NewCarLoanCalculatorSummary/NewCarLoanCalculatorSummary.init.js';

import NewCarLoanCalculatorInput from '../../Frontend/src/components/NewCarLoanCalculator/NewCarLoanCalculatorInput/NewCarLoanCalculatorInput.init.js';

import NewCarLoanCalculatorResult from '../../Frontend/src/components/NewCarLoanCalculator/NewCarLoanCalculatorResult/NewCarLoanCalculatorResult.init.js';

import NykAlert from './components/NykAlert/NykAlert.init.js'

import SearchInputField from './components/SearchInputField/SearchInputField.init.js'

import SearchOverlay from './components/SearchOverlay/SearchOverlay.init.js'

import SendCalculation from './components/SendCalculation/SendCalculation.init.js'

import SendCalculationStepContent from './components/SendCalculationStepContent/SendCalculationStepContent.init.js'

import SendDocumentBlock from './components/SendDocumentBlock/SendDocumentBlock.init.js'

import SiteSearching from './components/SiteSearching/SiteSearching.init.js'

import SiteSearchingResult from './components/SiteSearchingResult/SiteSearchingResult.init.js'

import StickyBox from './components/StickyBox/StickyBox.init.js'

import TheForms from './components/TheForms/TheForms.init.js'

import ThemeSwitch from './components/ThemeSwitch/ThemeSwitch.init.js'

import Tooltip from './components/Tooltip/Tooltip.init.js'


export default function(Store){
   ArticlesInsight(Store)
   ContextBanner(Store)
   CalculatorCompareTable(Store)
   CalculatorSummary(Store)
   FormRadioGroupInput(Store)
   NewLoanCalculatorInputs(Store)
   NewLoanCalculatorInput(Store)
   AdjustLoanContent(Store)
   SwitchLoanTypeContent(Store)
   NewLoanCalculatorResult(Store)
   NewLoanCalculatorResultDesktop(Store)
   NewLoanCalculatorResultMobile(Store)
   HighchartGraph(Store)
   SignupMultipleNewsletters(Store)
   SignupSingleNewsletter(Store)
   SignupStepActions(Store)
   SignupStepEmail(Store)
   SignupStepFullname(Store)
   SignupStepReceipt(Store)
   SignupStepSelectNewsletters(Store)
   SendCalculationStepActions(Store)
   VideoBlock(Store)
   FindCenterContactPersons(Store)
   FindCenterMapAndEmployees(Store)
   CenterMap(Store)
   JobApplication(Store)
   FooterContact(Store)
   Menu(Store)
   FeedbackBlock(Store)
   FeedbackStepOne(Store)
   FeedbackStepThree(Store)
   FeedbackStepTwo(Store)
   CardMediumPI(Store)
   PIMap(Store)
   AnkerMenu(Store)
   MitNykreditMenu(Store)
   Breadcrumbs(Store)
   AiAssistant(Store)
   AnnualReportsTable(Store)
   CalculatorInfoBox(Store)
   CalculatorTable(Store)
   ChatPanel(Store)
   ChatPanelFloatingTrigger(Store)
   ChatPanelTrigger(Store)
   ContactAdvisorBlock(Store)
   ContactCard(Store)
   ContactCardBasic(Store)
   ContactCardOnboarding(Store)
   ContactCardPermission(Store)
   ContactStepCategoryContent(Store)
   ContactStepComments(Store)
   ContactStepContent(Store)
   ContactStepIntro(Store)
   ContactStepNewsletters(Store)
   ContactStepOnboardingContent(Store)
   CurrentFundPrices(Store)
   CustomForm(Store)
   DocumentArchive(Store)
   DynamicDocumentList(Store)
   DynamicTable(Store)
   FeedbackToolbar(Store)
   FilterTabs(Store)
   GenericInput(Store)
   GoogleMapsWithMarkers(Store)
   HistoricFundPrices(Store)
   InvestmentFundTable(Store)
   JobPostingsTable(Store)
   LegalText(Store)
   Modal(Store)
   MultiSelectDropdown(Store)
   NewCarLoanCalculatorAdjustLoan(Store)
   NewCarLoanCalculatorInputs(Store)
   NewCarLoanCalculatorSummary(Store)
   NewCarLoanCalculatorInput(Store)
   NewCarLoanCalculatorResult(Store)
   NykAlert(Store)
   SearchInputField(Store)
   SearchOverlay(Store)
   SendCalculation(Store)
   SendCalculationStepContent(Store)
   SendDocumentBlock(Store)
   SiteSearching(Store)
   SiteSearchingResult(Store)
   StickyBox(Store)
   TheForms(Store)
   ThemeSwitch(Store)
   Tooltip(Store)
}